<template>
    <div>
        <ValidationObserver ref="form" class="centerx default-input" v-slot="{handleSubmit}">
            <vs-row>
                <vs-col vs-w="12">
                    <div class="mb-4">
                        <ValidationProvider vid="name" :name="$t('global.Name')" rules="required|minmax:3,50" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Name')}}</label>
                            <vs-input class="inputx w-full" :placeholder="$t('global.Name')" v-model="name" name="name" />
                            <span class="text-danger text-xs">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="12">
                    <div class="mb-4">
                        <ValidationProvider vid="description" :name="$t('global.Description')" rules="required|min:3" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Description')}}</label>
                            <vs-input class="inputx w-full" :placeholder="$t('global.Description')" name="description" v-model="description" />
                            <span class="text-danger text-xs">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col :vs-w="popupType === 'addPermissionModule' || popupType === 'editPermissionModule' ? 6 : 12">
                    <div class="mb-4" :class="{'mr-2': popupType === 'addPermissionModule' || popupType === 'editPermissionModule'}">
                        <ValidationProvider vid="roles" :name="$t('global.Roles')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Roles')}}</label>
                            <v-select appendToBody :calculate-position="withPopper" :placeholder="$t('global.Roles')" name="roles" multiple :closeOnSelect="false" class="w-full popup__select" v-model="roles" :options="rolesItems" />
                            <span class="text-danger text-xs">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col v-if="popupType === 'addPermissionModule' || popupType === 'editPermissionModule'" vs-w="6">
                    <div class="mb-4 ml-2">
                        <ValidationProvider vid="roles_ids" :name="$t('global.Role_access')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Role_access')}}</label>
                            <v-select appendToBody :calculate-position="withPopper" :placeholder="$t('global.Role_access')" name="roles_ids" multiple :closeOnSelect="false" class="w-full popup__select" v-model="role_access_permission" :options="rolesItems" />
                            <span class="text-danger text-xs">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col v-if="popupType === 'addPermissionModule' || popupType === 'editPermissionModule'" vs-w="12">
                    <div class="flex items-center mb-4">
                        <vs-checkbox v-model="custom_slug"/>
                        <div>{{$t('global.Custom_slug')}}</div>
                    </div>
                </vs-col>
                <vs-col v-if="popupType === 'addPermissionModule' || popupType === 'editPermissionModule'" vs-w="12">
                    <div class="mb-4" v-if="isMounted">
                        <ValidationProvider vid="slug" :name="$t('global.Slug')" rules="required|minmax:3,50" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Slug')}}</label>
                            <vs-input class="inputx w-full" v-if="custom_slug" :placeholder="$t('global.Slug')" name="slug" v-model="slug" />
                            <v-select appendToBody :calculate-position="withPopper" taggable :placeholder="$t('global.Slug')" v-else name="slug" class="w-full popup__select" :clearable="false" v-model="slug" :options="slugItems" :reduce="slug => slug.value" label="label" />
                            <span class="text-danger text-xs">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="12">
                    <div class="text-right">
                        <vs-button @click="handleSubmit(sendData)" color="primary" type="filled">{{$t('buttons.Save')}}</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </ValidationObserver>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import EventBus from '@/store/eventBus'
import {vSelectPosition} from "@/utils/mixins";

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition],

    data() {
        return {
            isMounted: false,

            name: '',
            description: '',
            slug: '',
            sl: {},
            roles: [],
            role_access_permission: [],

            rolesItems: [],
            permissions: [],
            slugItems: [
                {label: 'Access', value: 'access'},
                {label: 'Create', value: 'create'},
                {label: 'Update', value: 'update'},
                {label: 'Destroy', value: 'destroy'}
            ],
            custom_slug: false
        }
    },

    components: {
        vSelect
    },

    watch: {
        slug(data) {
            this.slug = data
        }
    },

    methods: {
        slugName(name) {
            if(name) {
                return name.split(' ').map(item => item.toLowerCase()).join('_')
            }
        },

        async sendData() {
            try {
                const data = {
                    name: this.name.trim(),
                    description: this.description.trim(),
                    slug: (this.slug ? this.slug : this.slugName(this.name)).trim(),
                    role_ids: this.roles.map(item => (item.value)),
                    role_access_permission: this.role_access_permission.map(item => (item.value))
                }

                if(this.popupType === 'editPermission' || this.popupType === 'editPermissionModule') {
                    data.id = this.popupData.data.id
                }

                if(!data.role_access_permission.length) {
                    delete data.role_access_permission
                }

                if(this.popupType === 'createPermission' || this.popupType === 'editPermission') {
                    await send(this.$url.permission.create, 'POST', {data: {permission_module: data}})
                }

                if(this.popupType === 'addPermissionModule' || this.popupType === 'editPermissionModule') {
                    await send(this.$url.permission.update, 'PUT', {data: {permission_module_id: (this.popupData.module && this.popupData.module.id) || (this.popupData.data && this.popupData.data.id), permission: data}})
                }

                EventBus.$emit('SUCCESS')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getRoles() {
            try {
                const response = await send(this.$url.role.get, 'GET')
                return response.data.result
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        try {
            this.rolesItems = this.popupData.rolesItems
            if(this.popupType === 'editPermission') {
                this.name = this.popupData.data.name
                this.description = this.popupData.data.description
                this.roles = this.popupData.data.role_ids.map(item => this.rolesItems.find(list => list.value === item))
            }

            if(this.popupType === 'editPermissionModule') {
                this.name = this.popupData.data.name
                this.description = this.popupData.data.description
                this.roles = this.popupData.data.role_ids.map(item => this.rolesItems.find(list => list.value === item))
                this.role_access_permission = this.popupData.data.role_access_permission.map(item => this.rolesItems.find(list => list.value === item))

                const slugList = this.slugItems.map(element => element.value)
                if(!slugList.includes(this.popupData.data.slug.toLowerCase())) {
                    this.custom_slug = true
                }
                this.slug = this.popupData.data.slug
            }
            this.isMounted = true

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>
